import { Button, Dialog, Spinner } from 'construct-ui';
// import { v4 as uuidv4 } from 'uuid';
import ConfirmationDialogView from '../../../components/common/confirmation-box.view';
import { messageComponent } from '../../../components/message/message.component';
import paginationComponent from '../../../components/pagination/pagination.component';
import SingleSelectComponent from '../../../components/single-select/single-select.component';
import { WORK_TEMPLATE_STATUS } from '../../../config/constants';
import workTemplateModel from '../../../models/schedule/work-template.modal';
import ViewBase from '../../view-base.view';
import WorkTemplateRemarksView from './work-template-remarks.view';
import WorkTypeView from './work-types.view';
import { exportRetailExcelTemplate } from "../../../models/file.model"

export default function WorkTemplateView() {
  ViewBase.call(this);

  let inputDataModel = { iconList: [], selectedWorkType: "", name: "", status: WORK_TEMPLATE_STATUS[0].code, data: [], pageIndex: 1, pageSize: 10, totalCount: 0, workType: [], masterId: "0", selectedStatus: "" };
  let deactivateLabel = "";
  let isLoading = false;
  let isMsgOpen = false;
  let showMsg = "";
  let msgTitle = "";
  let isDeleteOpen = false;
  let isSpecialTaskType = false;

  let _onLoadDetailView = (masterId, workType, iconList) => { }

  let _getName = (e) => {
    inputDataModel.name = e.target.value;
    _search();
  }

  let _getStatus = (e) => {
    inputDataModel.status = e;
    _search();
  }

  let _search = () => {
    inputDataModel.pageIndex = 1;
    _loadWorkTemplateList();
  }

  let _deleteConfirmation = (id, status) => {
    inputDataModel.selectedStatus = status == '001' ? '002' : '001';
    inputDataModel.masterId = id;
    deactivateLabel = status == "001" ? this.getText("LT00000167", "Are you sure you want to deactivate?") : this.getText("LT00000168", "Are you sure you want to activate?");
    isDeleteOpen = true;
  }

  let _changeStatus = () => {
    isLoading = true;
    workTemplateModel.changeStatusOfWorkType(
      (result) => {
        isDeleteOpen = false;
        isLoading = false;
        isMsgOpen = true;
        showMsg = result[0].transStatus;
        msgTitle = this.getText(result[0].code);
        inputDataModel.selectedStatus = "";
        _loadWorkTemplateList();
      },
      (error) => {
        isDeleteOpen = false;
        isLoading = false;
        this.handleError(error);
      },
      inputDataModel.masterId, inputDataModel.selectedStatus
    )
  }

  let _loadWorkTemplateList = () => {
    isLoading = true;

    workTemplateModel.getWorkTemplateList(
      (result) => {
        isLoading = false;
        inputDataModel.data = result.data;
        inputDataModel.totalCount = result.total;
      },
      (error) => {
        isLoading = false;
        this.handleError(error);
      },
      inputDataModel
    )
  }

  let _loadWorkTypeList = () => {
    inputDataModel.workType = [];
    workTemplateModel.getWorkTypeList(
      (result) => {
        inputDataModel.iconList = [];
        inputDataModel.workType.push({ sequence: "0", code: "", name: this.getText("LT00000143", "All") });
        result.forEach((item) => {
          inputDataModel.workType.push(item);
          if (item.code == "001")//Work
            inputDataModel.iconList.push({ code: item.code, icon: "bi-file-person-fill", color: "", Text: "" });
          if (item.code == "002")//Leave
            inputDataModel.iconList.push({ code: item.code, icon: "bi-calendar-check-fill", color: "", Text: "" });
          if (item.code == "003")//Day off
            inputDataModel.iconList.push({ code: item.code, icon: "bi-umbrella-fill", color: "", Text: "" });
          if (item.code == "004")//Training
            inputDataModel.iconList.push({ code: item.code, icon: "bi-stack", color: "", Text: "" });
          if (item.code == "005")//Road Show
            inputDataModel.iconList.push({ code: item.code, icon: "bi-sunglasses", color: "", Text: "" });
          if (item.code == "006")//Others
            inputDataModel.iconList.push({ code: item.code, icon: "bi-cup-straw", color: "", Text: "" });
          if (item.code == "007")//No schedule
            inputDataModel.iconList.push({ code: item.code, icon: "bi-calendar2-x-fill", color: "", Text: "" });
        });
      },
      (error) => {
        isLoading = false;
        this.handleError(error);
      }
    )
  }

  let _initControls = () => {
    _loadWorkTemplateList();
    _loadWorkTypeList();
  }

  const _downloadExcel = () => {
    this.showLoading();
    const fileName = 'Work Template List.xlsx';
    const exportConfig = {
      storedProcedureCode: "10",
      params: [
        { code: "28", value: inputDataModel.selectedWorkType },
        { code: "29", value: inputDataModel.name },
        { code: "2", value: "" },
        { code: "24", value: "" },
        { code: "3", value: "0" },
        { code: "4", value: "0" }
      ],
      excelSheetNames: ["Work Templatester List", "Work Template Count"]
    };
    exportRetailExcelTemplate(exportConfig, fileName)
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        this.hideLoading();
      });

  }

  let onPageSizeChanged = (pageIndex, pageSize) => {
    inputDataModel.pageIndex = pageIndex;
    inputDataModel.pageSize = pageSize;
    _loadWorkTemplateList();
  }

  let onPageChanged = (pageIndex) => {
    inputDataModel.pageIndex = pageIndex;
    _loadWorkTemplateList();
  }

  let _registerWorkTemplate = () => {
    _onLoadDetailView("0", inputDataModel.workType, inputDataModel.iconList);
  }

  let _dialogClosed = () => {
    isMsgOpen = false;
  }

  let _onWorkTypeChanged = (type) => {
    isSpecialTaskType = (type === "007") ? true : false;
    if (inputDataModel.selectedWorkType != type) {
      inputDataModel.selectedWorkType = type;
      inputDataModel.pageIndex = 1;
      _loadWorkTemplateList();
    }
  }

  let _loadDetails = (id) => {
    _onLoadDetailView(id, inputDataModel.workType, inputDataModel.iconList);
  }

  return {
    oninit: (vnode) => {
      if (vnode.attrs.onLoadDetailView) {
        _onLoadDetailView = vnode.attrs.onLoadDetailView;
      }
      _initControls();
    },
    view: (vnode) => {
      return [
        m('.row',
          m(Spinner, {
            active: isLoading,
            background: true,
            fill: true,
            size: 'xl',
          }),
          m('.col-12',

            // Title
            m('.d-flex.justify-content-end.align-items-end.mb-3',
              m('button.btn.btn-outline-primary.btn-add.mb-2',
                { onclick: _registerWorkTemplate }, [
                m("i.bi.bi-plus-lg.me-0"),
              ]),
            ),

            // Search section
            m('.card.mb-3',
              m('.card-body',
                m('.row.mb-3',
                  m('.col-md-4',
                    m('label.form-label', this.getText("LT00000011", "Name")),
                    m('input[type=text][placeholder=' + this.getText("LT00000011", "Name") + '][value="' + inputDataModel.name + '"].form-control.form-control-bg', { onkeyup: _getName })
                  ),
                  m('.col-md-4',
                    m('label.form-label', this.getText("LT00000015", "Status")),
                    m(SingleSelectComponent, {
                      id: "workStatus",
                      items: WORK_TEMPLATE_STATUS,
                      selectedItem: inputDataModel.status,
                      onSelect: (s) => _getStatus(s),
                      filterable: false,
                      keyOnly: true,
                    })
                  ),
                ),
                m('.row',
                  m('.col-12.workTemplateButtonWrapper',
                    m(WorkTypeView, { workType: inputDataModel.workType, selectedWorkType: inputDataModel.selectedWorkType, onChange: _onWorkTypeChanged })
                  )
                ),
              )
            ),

            // Table section
            m('.card',
              m('.card-body',
                m('.d-flex.justify-content-end.mb-2',
                  m('a.btn.btn-primary', { onclick: _downloadExcel },
                    m('i.bi.bi-file-earmark-arrow-down-fill'), this.getText("LT00000018", "Excel Download"),
                  )
                ),
                m('.row',
                  m(".col-12.p-0",
                    m(".table-responsive",
                      m("table.table",
                        [
                          m("thead.thead-bggrey",
                            m("tr.align-middle", [
                              m("th", { "scope": "col" }, this.getText("LT00000011", "Name")),
                              m("th", { "scope": "col" }, this.getText("LT00000117", "Type")),
                              isSpecialTaskType && m("th", { "scope": "col" }, this.getText("LT00000367", "Sub-category")),
                              m("th.center", { "scope": "col" }, this.getText("LT00000148", "Display Seq")),
                              m("th", { "scope": "col" }, this.getText("LT00000079", "Permission")),
                              m("th.center", { "scope": "col" }, this.getText("LT00000015", "Status")),
                              m("th", { "scope": "col" }, this.getText("LT00000108", "Details")),
                              m("th.center", { "scope": "col" }, this.getText("LT00000092", "Action"))
                            ])
                          ),
                          m("tbody",
                            inputDataModel.data.length == 0 &&
                            m("tr", { "class": "align-middle" },
                              m("td", { "colspan": "7" }, this.getText("EM00000141", "No records found."))
                            ),
                            inputDataModel.data.map(gc =>
                              [
                                m("tr",
                                  [
                                    m("td", gc.workTemplateName),
                                    m("td", gc.workTypeName),
                                    isSpecialTaskType && m("td", gc.leaveDayOffName),
                                    m("td.center", gc.sequence),
                                    m("td", gc.permission.trim() == '001' && m('span.bullet-blue', m('i.bi.bi-circle-fill'), gc.permissionName),
                                      gc.permission.trim() == '002' && m('span.bullet-yellow', m('i.bi.bi-circle-fill'), gc.permissionName)),
                                    m("td.center", gc.status == '002' && m('.badge.rounded-pill.grey-bg-status', gc.statusName),
                                      gc.status == '001' && m('.badge.rounded-pill.green-bg-status', gc.statusName)
                                    ),
                                    m("td", m(WorkTemplateRemarksView, { data: gc })),
                                    m("td.center",
                                      m('i.bi.bi-pencil-square.list-action-icon[title="Edit"]', { onclick: () => { _loadDetails(gc.workTemplateId); } }),
                                      gc.status == "001" && m('i.bi.bi-trash-fill.list-action-icon[title="Delete"]', { onclick: () => { _deleteConfirmation(gc.workTemplateId, gc.status); } }),
                                      gc.status == "002" && m('i.bi.bi-arrow-counterclockwise.list-action-icon[title="Activate"]', { onclick: () => { _deleteConfirmation(gc.workTemplateId, gc.status); } }),
                                    )
                                  ])
                              ]),
                          )
                        ])
                    ),
                    !isLoading &&
                    m(".px-3",
                      m(paginationComponent, { currentPage: inputDataModel.pageIndex, pageSize: inputDataModel.pageSize, totalItems: inputDataModel.totalCount, onPageChanged: onPageChanged, onPageSizeChanged: onPageSizeChanged })
                    )
                  )
                )
              )
            )
          ),
          m(Dialog, {
            isOpen: isDeleteOpen,
            transitionDuration: 200,
            closeOnOutsideClick: false,
            onClose: () => { isDeleteOpen = false; },
            title: this.getText("LT00000043", "Confirm"),
            content: m(ConfirmationDialogView, { text: deactivateLabel }),
            "class": "cui-dialog",
            footer: [
              m(Button, {
                label: this.getText("LT00000024", "No"),
                onclick: () => { isDeleteOpen = false; }
              }),
              m(Button, {
                label: this.getText("LT00000023", "Yes"),
                intent: 'primary',
                onclick: _changeStatus
              })
            ]
          }),
          m(messageComponent, { isOpen: isMsgOpen, message: showMsg, title: msgTitle, onClosed: _dialogClosed })
        ),
        this.getBaseViews()
      ]
    }
  }
}
